import React, { useState } from 'react'
import Layout from '../../layout'
import Breadcrums from '../../components/common/breadcrumbs'
import ZatcaQueue from './zatca/ZatcaQueue'
import OrdersQueue from './orders/OrdersQueue'
import ErpQueue from './erp/ErpQueue'
import BackgroundTasksQueue from './background-tasks/BackgroundTasksQueue'
import CriticalTasksQueue from './critical-tasks/CriticalTasksQueue'

// One tab per queue. Each queue owns its own screen — they only share the
// admin queue endpoints (useQueue), the card chrome (QueuePanel) and the
// job-view primitives (jobDisplay).
const QUEUES = [
    { key: 'zatca', label: 'Zatca', component: ZatcaQueue },
    { key: 'orders', label: 'Orders', component: OrdersQueue },
    { key: 'erp', label: 'ERP Sync', component: ErpQueue },
    { key: 'background-tasks', label: 'Background Tasks', component: BackgroundTasksQueue },
    { key: 'critical-tasks', label: 'Critical Tasks', component: CriticalTasksQueue },
]

const QueuesPage = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/admin/dashboard" }, { title: "Queues", url: "" }]

    const [activeQueue, setActiveQueue] = useState('zatca')

    // Mounted fresh per tab, so switching queues starts from a clean fetch
    // instead of showing the previous queue's jobs while the new ones load.
    const ActiveComponent = (QUEUES.find(q => q.key === activeQueue) || QUEUES[0]).component

    return (
        <Layout>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">

                <ul className="nav nav-tabs mb-3">
                    {QUEUES.map((q) => (
                        <li className="nav-item" key={q.key}>
                            <button
                                className={`nav-link ${activeQueue === q.key ? 'active' : ''}`}
                                onClick={() => setActiveQueue(q.key)}
                            >
                                {q.label}
                            </button>
                        </li>
                    ))}
                </ul>

                <ActiveComponent />
            </div>
        </Layout>
    )
}

export default QueuesPage
